<template>
  <div id="package-creation-contracts">
    <item-tile
      v-for="(contract, index) in filteredSubject"
      :key="index"
      :heading="contract.contractName"
      :selected="true"
      @click="removeContract(contract)"
    />
    <item-tile
      v-for="(contract, index) in contracts"
      :key="index"
      :selected="false"
      :heading="contract.contractName"
      @click="addContract(contract)"
    />
  </div>
</template>
<script>
import ItemTile from "../../../../../../Components/UI/ItemTile.vue";
export default {
  data() {
    return {};
  },
  computed: {
    contracts() {
      return this.$store.getters.contracts.filter((x) => {
        return !this.subject.contracts.includes(x);
      });
    },
    filteredSubject() {
      return this.subject.contracts.filter((x) => {
        return x;
      });
    },
  },
  methods: {
    addContract(contract) {
      this.$emit("add-contract", contract);
    },
    removeContract(contract) {
      this.$emit("remove-contract", contract);
    },
  },
  components: {
    ItemTile,
  },
  emits: ["add-contract", "remove-contract"],
  props: ["subject"],
};
</script>
<style scoped>
#package-creation-contracts {
  display: flex;
  overflow: scroll;
  padding: 25px;
}
</style>
